import moment from 'moment'

export const STATIC_INFORMATION = [
  {
    id: 'static-closed-20260914',
    title: '🌻臨時休診のお知らせ🌻',
    content: `平素よりのぞみクリニック築地をご利用いただき、誠にありがとうございます。
誠に勝手ながら、9月14日（月）は休診とさせていただきます。
火曜日は通常通り診療いたします。
ご不便をおかけいたしますが、何卒ご理解のほどよろしくお願いいたします。`,
    createTime: '2026-09-13',
  },
  // {
  //   id: 'static-halfday-20260829',
  //   title: '🌻臨時休診のお知らせ🌻',
  //   content: `平素よりのぞみクリニック築地をご利用いただき、誠にありがとうございます。
  // 誠に勝手ながら、8月29日（土）は午後休診とさせていただきます。
  // 午前は通常通り診療いたします。
  // ご不便をおかけいたしますが、何卒ご理解のほどよろしくお願いいたします。`,
  //   createTime: '2026-08-28',
  // },
  // {
  //   id: 'static-obon-20260811',
  //   title: '🌻休診のお知らせ🌻',
  //   content: `平素よりのぞみクリニック築地をご利用いただき、誠にありがとうございます。
  // 誠に勝手ながら、下記の期間は休診とさせていただきます。
  // ■ 8月11日（火・祝）　祝日
  // ■ 8月12日（水）　定休日
  // ■ 8月13日（木）～8月15日（土）　お盆休み
  // ■ 8月16日（日）　日曜日
  // 8月17日（月）より通常どおり診療いたします。
  // 患者様にはご不便をおかけいたしますが、何卒ご理解のほどよろしくお願い申し上げます。`,
  //   createTime: '2026-08-10',
  // },
  // {
  //   id: 'static-typhoon-20260627',
  //   title: '台風による臨時休業のお知らせ',
  //   content: `平素はのぞみクリニック築地をご利用いただき、誠にありがとうございます。
  // 大変恐縮ではございますが、6月27日(土)は、ダブル台風の接近による交通機関の乱れが予想されますので、臨時休業とさせていただきます。
  // 来週月曜日、6月29日(月)は通常通り営業を予定しております。
  // ご迷惑をおかけ、申し訳ございません。`,
  //   createTime: '2026-06-26',
  // },
]

export function formatInformationTime(list) {
  return list.map(item => ({
    ...item,
    createTime: moment(item.createTime).format('YYYY.MM.DD'),
  }))
}

export function getStaticInformationById(id) {
  // 兼容旧版台风通知 ID
  if (String(id) === 'static-typhoon-20250627') {
    id = 'static-typhoon-20260627'
  }
  return STATIC_INFORMATION.find(item => String(item.id) === String(id)) || null
}

export function mergeStaticInformation(apiData) {
  const data = Array.isArray(apiData) ? apiData : []
  const staticItems = STATIC_INFORMATION.map(item => ({ ...item }))
  return [...staticItems, ...data].sort((a, b) => {
    const t1 = new Date(a.createTime)
    const t2 = new Date(b.createTime)
    return t2.getTime() - t1.getTime()
  })
}

export function getMergedInformationList(apiData, limit) {
  const list = formatInformationTime(mergeStaticInformation(apiData))
  return typeof limit === 'number' ? list.slice(0, limit) : list
}
